import { Ref } from "vue";

interface ICaller {
    id: string;
    phone_number: string;
    extension_number: string;
    timezone: string;
    display_name: string;
    extension_type: string;
    site_id: string;
    site_name: string;
}

interface ICallee {
    phone_number: string;
    extension_number: string;
}

interface ILocation {
    ip: string[];
    gps?: string[];
}

export interface ServerEventResponse {
    event: string;
    payload: {
        object: {
            caller: ICaller;
            callee: ICallee;
            location: ILocation;
            router: string;
            call_id: string;
            ringing_start_time: string;
            emergency_address: IEmergencyAddress
            deliver_to: string;
        }
        account_id: string;
    }
    event_ts: number;
}
export interface IEmergencyAddress {
    address_line1: string;
    address_line2?: string;
    city: string;
    country: string;
    state_code: string;
    zip: string;
}

export interface ServerEventState {
    receivedEvents: ServerEventResponse[];
    connectionStatus: boolean;
    receivedEventsSizeLimit: number
}

export interface SiteCallState {
    emergencyCalls: ServerEventResponse[];
    nonEmergencyCalls: ServerEventResponse[];
    displayLimit: number;
    playAlertAudio: boolean;
}

export interface ISiteLookupTable {
    [key: string] : {
        name: string, 
        emergency: ServerEventResponse[], 
        emergencyGetter: Ref<ServerEventResponse[]>, 
        nonEmergency: ServerEventResponse[]
        nonEmergencyGetter: Ref<ServerEventResponse[]>, 
    };
}

export const AnnArborSiteID = process.env.VUE_APP_ANN_ARBOR_SITE_ID as string;
export const FlintSiteID = process.env.VUE_APP_FLINT_SITE_ID as string;
export const DearbornSiteID = process.env.VUE_APP_DEARBORN_SITE_ID as string;
